import { Button } from "@/components/ui/button";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { Toolbar, ToolbarItem } from "@/components/ui/toolbar";
import { ArrowUpOnSquareIcon } from "@heroicons/react/24/outline";
import { Squares2X2Icon, ChartBarIcon, Bars3Icon } from "@heroicons/react/24/solid";
import { CopilotButton } from "./co-pilot-button";

/* Prop Types */
interface AttentionReportsSkeletonProps {
  title?: string;
}

/*
 * AttentionReportsSkeleton component
 * Skeleton component used for study-upload and study-review page
 */
export const AttentionReportsSkeleton = ({ title = "Attention" }: AttentionReportsSkeletonProps) => {
  /* Render */
  return (
    <>
      <Toolbar>
        <ToolbarItem>
          <h1 className="font-semibold">{title}</h1>
        </ToolbarItem>
        <ToolbarItem>
          <CopilotButton />
          <Button>
            <ArrowUpOnSquareIcon className="size-3.5" />
            Export
          </Button>
        </ToolbarItem>
      </Toolbar>

      <Toolbar>
        <ToolbarItem>
          <div className="skeleton w-28 h-9 rounded-lg"></div>
          <div className="skeleton w-28 h-9 rounded-lg"></div>
          <div className="skeleton w-28 h-9 rounded-lg"></div>
          <div className="skeleton w-28 h-9 rounded-lg"></div>
        </ToolbarItem>
        <ToolbarItem>
          <CustomDropdown
            align="end"
            triggerBtnClassname="p-0"
            triggerBtn={
              <Button>
                <Squares2X2Icon className="size-3.5" />
                Cards
              </Button>
            }
          >
            <CustomDropdownItem>
              <Squares2X2Icon className="size-4" />
              Cards
            </CustomDropdownItem>
            <CustomDropdownItem>
              <Bars3Icon className="size-4" />
              List
            </CustomDropdownItem>
            <CustomDropdownItem>
              <ChartBarIcon className="size-4" />
              Charts
            </CustomDropdownItem>
          </CustomDropdown>
        </ToolbarItem>
      </Toolbar>

      <div className="flex flex-row gap-4 flex-wrap">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="card bg-base-100 border-2 border-base-300 min-w-72 max-w-60">
            {/* Skeleton Image */}
            <div className="skeleton min-h-44 max-h-44 w-full rounded-t-lg rounded-b-none" />

            {/* Skeleton Content */}
            <div className="px-6 py-7 space-y-3">
              <div className="skeleton h-4 w-full rounded-lg" />

              <div className="flex flex-row gap-2">
                <div className="skeleton h-4 w-3/5 rounded-lg" />
                <div className="skeleton h-4 w-2/5 rounded-lg" />
              </div>
              <div className="flex flex-row gap-2">
                <div className="skeleton w-4 h-4 rounded-full"></div>
                <div className="skeleton h-4 w-3/5 rounded-lg" />
                <div className="skeleton h-4 w-2/5 rounded-lg" />
              </div>
              <div className="flex flex-row gap-2">
                <div className="skeleton w-4 h-4 rounded-full"></div>
                <div className="skeleton h-4 w-3/5 rounded-lg" />
                <div className="skeleton h-4 w-2/5 rounded-lg" />
              </div>
              <div className="flex flex-row gap-2">
                <div className="skeleton w-4 h-4 rounded-full"></div>
                <div className="skeleton h-4 w-3/5 rounded-lg" />
                <div className="skeleton h-4 w-2/5 rounded-lg" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
